// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"727":"f22299a2ce07b7dc","914":"ab1ba968691c6111"}[chunkId] + ".js";
};